export const SELF_SERVE_TENANT_ID = "self-serve";
export const ENROLL_PATH = `/enroll`;
export const GOAL_OPTIONS = [
  "Price monitoring and enforcement",
  "Unauthorized seller detection",
  "MAP policy enforcement",
  "Brand protection",
  "Market intelligence",
  "Not sure yet",
];

export const REFERRAL_SOURCE_OPTIONS = [
  "Google or other search tool",
  "ChatGPT or other AI tool",
  "Tradeshow, Conference, or Industry Event",
  "LinkedIn or Facebook",
  "Referral from a friend or colleague",
  "We emailed you",
  "Newsletter or article",
  "Podcast",
  "Other",
];

export const MARKETPLACE_OPTIONS = [
  "Amazon",
  "Walmart",
  "eBay",
  "Google Shopping",
  "Other",
];

export const ONBOARDING_STEPS = {
  initializing: "initializing",
  survey: "survey",
  catalog: "catalog",
  verifyEmail: "verify",
  finalizing: "finalizing",
  upgrade: "upgrade",
  none: "none",
  complete: "complete",
} as const;

export const CANONICAL_PRODUCT_HEADERS = [
  "name",
  "amazonId",
  "sku",
  "brand",
  "upc",
  "map",
  "trademark",
] as const;

export interface SurveyFormData {
  companyName: string;
  goals: string[];
  referralSource: string;
}

export const SETUP_STEPS = [
  {
    label: "Creating your profile",
    description: "Setting things up",
  },
  {
    label: "Configuring authentication",
    description: "Securing your account",
  },
  {
    label: "Uploading product catalog",
    description: "Importing your products",
  },
  {
    label: "Scanning your products",
    description: "Gathering data on sellers. This may take a few minutes...",
  },
  {
    label: "Creating cases",
    description: "Get ready!",
  },
  {
    label: "Finalizing setup",
    description: "Almost done!",
  },
];
